// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-select-wrap .vs__selected-options{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.v-select-wrap .vs__selected-options .vs__selected{padding:0;margin:0}.v-select-wrap .vs__dropdown-menu{-webkit-box-shadow:2px 4px 8px rgba(0,0,0,.3);box-shadow:2px 4px 8px rgba(0,0,0,.3)}", ""]);
// Exports
module.exports = exports;
